import '../styles/index.css'
import MainPage from './main'

// process.env.GATSBY_ACTIVE_ENV === 'production' && typeof window !== "undefined" && typeof window.gtag !== "undefined" && window.gtag('event', 'conversion', {'send_to': 'AW-XXXXXX'})

export default MainPage
